import React from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const Header = () => {
  let tok = jwtDecode(localStorage.getItem("ttk"));
  if(tok.role == 1 || tok.role == 99) {
    return (
      <Menu mode="horizontal">
        <Menu.Item key="products"><Link to="/products">Товары</Link></Menu.Item>
        <Menu.Item key="partners"><Link to="/partners">Партнеры</Link></Menu.Item>
        <Menu.Item key="clients"><Link to="/clients">Клиенты</Link></Menu.Item>
        <Menu.Item key="sales-points"><Link to="/sales-points">Точки продаж</Link></Menu.Item>
        <Menu.Item key="spheres"><Link to="/spheres">Сферы</Link></Menu.Item>
        <Menu.Item key="sales"><Link to="/sales">Продажи</Link></Menu.Item>
        <Menu.Item key="users"><Link to="/users">Пользователи</Link></Menu.Item>
        <Menu.Item key="logout"><Link to="/">Выйти</Link></Menu.Item>
      </Menu>
    );
  }

  if(tok.role == 2) {
  return (
      <Menu mode="horizontal">
        <Menu.Item key="sales"><Link to="/saler-sales">Продажи</Link></Menu.Item>
        <Menu.Item key="logout"><Link to="/">Выйти</Link></Menu.Item>
      </Menu>
    );
  }

};

export default Header;